var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onTheLand",style:({left:this.rleft,width:this.rwidth,height:this.rheight,bottom:this.rbottom,lineHeight:this.rheight }),attrs:{"id":"biscuit"}},[_vm._v(" 50")])}
var staticRenderFns = []

export { render, staticRenderFns }